import { render } from "./vsharedvcexfactory.vue?vue&type=template&id=5cdaa849&scoped=true"
import script from "./vsharedvcexfactory.vue?vue&type=script&lang=js"
export * from "./vsharedvcexfactory.vue?vue&type=script&lang=js"

import "./vsharedvcexfactory.vue?vue&type=style&index=0&id=5cdaa849&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cdaa849"]])

export default __exports__